<template>
    <el-container>
        <el-main>
            <div style="height: 50px; line-height: 50px;vertical-align: middle;">
                <div class="c_title" style="">
                    <el-button type="primary" @click="review()">审核一键通过</el-button>
                </div>
            </div>
            <el-steps :active="step" simple  class="" style="cursor: pointer">
                <el-step title="课程目录" @click.native="on_step(0)"></el-step>
                <el-step title="讨论" @click.native="on_step(1)"></el-step>
                <el-step title="作业" @click.native="on_step(2)"></el-step>
                <el-step title="测试" @click.native="on_step(3)"></el-step>
                <el-step title="资料" @click.native="on_step(4)"></el-step>
                <!--<el-step title="问答" @click.native="on_step(5)"></el-step>-->
            </el-steps>

            <template v-if="step == 0">
                <div class="courselist-warp  mt0 bg-white min-hegt">
                    <div class="video-cont-tab">
                        <CourseTree :course-list="courseList" :course-id="courseId" v-if="detail == 1" v-on:detailChanged="updateDetail"></CourseTree>
                        <detail :catalogId="catalogId" :resourceType="resourceType" :resourceId="resourceId" :course-id="courseId" v-if="detail == 2 " v-on:detailChanged="updateDetail"></detail>
                    </div>
                    <div style="width: 100%; text-align: center">
                        <el-button type="primary" style="margin-top: 10px;" @click="reviewCourse(1)">保存，进入下一步</el-button>
                    </div>
                </div>
            </template>
            <template v-if="step == 1">
                <div class="courselist-warp  mt0 bg-white min-hegt">
                    <div class="video-cont-tab">
                        <Discussion :course-list="courseList" :course-id="courseId"></Discussion>
                    </div>
                    <div style="width: 100%; text-align: center">
                        <el-button  @click="prev" >上一步</el-button>
                        <el-button type="primary" style="margin-top: 10px;" @click="reviewCourse(1)">保存，进入下一步</el-button>
                    </div>
                </div>
            </template>
            <template v-if="step == 2">
                <div class="courselist-warp  mt0 bg-white min-hegt">
                    <div class="video-cont-tab">
                        <Task :course-list="courseList" :course-id="courseId"></Task>
                    </div>
                </div>
                <div style="width: 100%; text-align: center">
                    <el-button  @click="prev" >上一步</el-button>
                    <el-button type="primary" style="margin-top: 10px;" @click="reviewCourse(1)">保存，进入下一步</el-button>
                </div>
            </template>
            <template v-if="step == 3">
                <div class="courselist-warp  mt0 bg-white min-hegt">
                    <div class="video-cont-tab">
                        <Test :course-list="courseList" :course-id="courseId"></Test>
                    </div>
                </div>
                <div style="width: 100%; text-align: center">
                    <el-button  @click="prev" >上一步</el-button>
                    <el-button type="primary" style="margin-top: 10px;" @click="reviewCourse(1)">保存，进入下一步</el-button>
                </div>
            </template>
            <template v-if="step == 4">
                <div class="courselist-warp  mt0 bg-white min-hegt">
                    <div class="video-cont-tab">
                        <Material :course-list="courseList" :course-id="courseId"></Material>
                    </div>
                </div>
                <div style="width: 100%; text-align: center">
                    <el-form ref="formData" :model="formData" label-width="80px" label-position="top">
                        <el-form-item label="审核意见" >
                            <el-input
                                type="textarea"
                                :rows="8"
                                placeholder="请填写课程审核意见"
                                v-model="formData.textarea">
                            </el-input>
                        </el-form-item>
                        <el-form-item align="center">
                            <el-button  @click="prev" >上一步</el-button>
                            <el-button type="primary" :disabled="saveLastDisable"  @click="save()">保存审核结果</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </template>
            <!--<template v-if="step == 5">-->
                <!--<div class="courselist-warp  mt0 bg-white min-hegt">-->
                    <!--<div class="video-cont-tab">-->
                        <!--<QA :course-list="courseList" :course-id="courseId"></QA>-->
                    <!--</div>-->
                <!--</div>-->
                <!--<el-form ref="formData" :model="formData" label-width="80px" label-position="top">-->
                    <!--<el-form-item label="审核意见" >-->
                        <!--<el-input-->
                            <!--type="textarea"-->
                            <!--:rows="8"-->
                            <!--placeholder="请填写课程审核意见"-->
                            <!--v-model="formData.textarea">-->
                        <!--</el-input>-->
                    <!--</el-form-item>-->
                    <!--<el-form-item align="center">-->
                        <!--<el-button  @click="prev" >上一步</el-button>-->
                        <!--<el-button type="primary"   @click="save()">保存审核结果</el-button>-->
                    <!--</el-form-item>-->
                <!--</el-form>-->
            <!--</template>-->
        </el-main>
    </el-container>
</template>

<script>
  import https from '@/https.js'
  import CourseTree from './CourseTree.vue'
  import Discussion from './Discussion.vue'
  import Task from './Task.vue'
  import Test from './Test.vue'
  import Material from './Material.vue'
  import QA from './Q&A.vue'
  import detail from './detail.vue'

  export default {
    name: "",
    inject:['reload'],
    components: {
      CourseTree: CourseTree,
      Discussion: Discussion,
      Task: Task,
      Test: Test,
      Material: Material,
      QA: QA,
      detail: detail,
    },
    data() {
      return {
        step: 0,
        detail: 1,
        courseId:'',
        catalogId: '',
        activeName: 'step1',
        checkSortList: [],
        courseList:[],
        currentStepName: 'step1',
        frameheight: 600,
        modelList: [],
        resourceType: '',
        resourceId: '',
        formData: {
          textarea: "",
        },
        saveLastDisable:false
      }
    },
    methods: {
      updateDetail(e) {
        console.log(111)
        this.catalogId = e.catalogId;
        this.resourceId = e.resourceId;
        this.detail = e.detail;
        this.resourceType = e.resourceType;
      },
      review() {
        // /courseCheck/checkPassAll
        let params = {
          courseId: this.courseId
        };
        https.fetchPost('/courseCheck/checkPassAll',params ).then((data) => {
              let code = data.data.code;
              let msg = data.data.msg;
              if(code == 200) {
                this.$message({
                  type: 'success',
                  message: '审核成功'
                });
                this.$router.push({path: 'courseReviewList'});
              } else {
                this.$message({
                  type: 'info',
                  message: '审核失败:'+msg
                });
              }
        })
      },
      save() {
        this.saveLastDisable=true;
        let params = {
          courseId: this.courseId,
          examineContext: this.formData.textarea
        };
        https.fetchPost('/courseCheck/checkCommit',params ).then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if(code == 200) {
            this.$message({
              type: 'success',
              message: '审核成功'
            });
            this.$router.push("/mall/courseReviewList")
          } else {
            this.$message({
              type: 'info',
              message: '审核失败:'+msg
            });
          }
          this.saveLastDisable=true;

        }).catch(err=>{
              this.$message.error('网络错误');
              this.saveLastDisable=true;
            }
        )
      },
      reviewCourse() {
        this.step = this.step+1;
      },
      prev() {
        this.step = this.step-1;
      },
      getModelList() {
        let params = {
          "courseId": this.courseId
        };
        https.fetchPost('/course/getModelList',params ,"json").then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if(code == '200') {
            this.modelList = data.data.data;
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:'+msg
            });
          }
        }).catch(err=>{
              console.log(err)
            }
        )
      },
      on_step(val) {
        if(val === 0) {
          this.reload();
        }
        this.step=val;
      },
    },
    mounted:function(){
      let data = this.$route.query;
      if(data.detail) {
        this.detail = data.detail;
      }
    },

    created: function () {
      let data = this.$route.query;
      console.log(data);
      if(!data.courseId) {
        this.$router.push("/mall/courseReviewList");
        return false;
      } else {
        this.courseId = data.courseId;
        this.getModelList();
      }

    }
  }
</script>

<style scoped>
    @import "./teacher.css";

    .c_title {
        float: left;
        font-size: 15px;
        height: 32px;
    }
</style>